module.exports = __webpack_public_path__ + "img/picnic_inner_1.1093726c.jpg";